import auth from './controllers/auth'
import users from './controllers/users'
import persons from './controllers/persons'
import slides from './controllers/slides'
import categories from './controllers/categories'
import entries from './controllers/entries'
import pages from './controllers/pages'

export default {
  auth,
  users,
  persons,
  slides,
  categories,
  entries,
  pages
}



// WEBPACK FOOTER //
// ./src/services/rest/index.js